import React from "react";
import "./button.css";

function Button() {
  return <button className="btn">get started</button>;
}

export default Button;
